import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import { SingleLineTextInput2023ViewModel } from "../ui2023";

import {
  FormLogicEventBehaviour,
  FormLogicEventBehaviour_OnChange,
  GenericTextFieldFormLogic,
} from "./generic";
import { maxEmailLength } from "../email-address-constants";

export interface EmailAddressFormLogicProps {
  formRef: React44ms.Api.TypedRef<SingleLineTextInput2023ViewModel>;
  disabled?: boolean;
}
export const EmailAddressFormLogic: React.FunctionComponent<
  EmailAddressFormLogicProps
> = (props) => (
  <GenericTextFieldFormLogic
    ref={props.formRef}
    required
    trim
    maxLength={maxEmailLength}
    conformsToRegex={emailRegEx}
    conformsToRegexMessage="Please enter a valid email address."
    behaviour={{
      onFocus: FormLogicEventBehaviour.nothing,
      onChange:
        FormLogicEventBehaviour_OnChange.onlyMutateWithoutValidation_AndResetValidationOnMutation,
      onBlur: FormLogicEventBehaviour.validate,
      onSubmit: FormLogicEventBehaviour.validate,
    }}
  />
);

const emailRegEx =
  /^([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*@([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*\.(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,})$/i;
